import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { PIE_COLORS } from '../../utils/constants';

const AllocationChart = ({ allocations, title = 'Stock Allocation' }) => {
  if (!allocations || allocations.length === 0) return null;

  const pieData = allocations.map((a) => ({
    name: a.name || a.ticker.replace('.NS', ''),
    value: a.weight,
  }));

  return (
    <div className="card">
      <h4 className="text-lg font-semibold text-gray-800 mb-4">{title}</h4>
      <div className="h-72">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={pieData}
              cx="50%"
              cy="50%"
              innerRadius={55}
              outerRadius={95}
              dataKey="value"
              label={({ name, value }) => `${name} ${value}%`}
            >
              {pieData.map((_, index) => (
                <Cell key={index} fill={PIE_COLORS[index % PIE_COLORS.length]} />
              ))}
            </Pie>
            <Tooltip formatter={(value) => `${value}%`} />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default AllocationChart;
